import { DateTime } from 'luxon';

export const API_DATE_FORMAT = 'yyyy-MM-dd';

export const formatDateToApiFormat = (date: DateTime): string => {
  return date.toFormat(API_DATE_FORMAT);
};

export const areDatesEqual = (date1?: DateTime | null, date2?: DateTime | null): boolean => {
  if (!date1 && !date2) {
    return true;
  }

  if (!date1 || !date2) {
    return false;
  }

  return date1.equals(date2);
};
